(function () {
  function initMobileMenu() {
    document.querySelectorAll('[data-ml-menu-button]').forEach(function (button) {
      var header = button.closest('.ml-header');
      if (!header) return;
      var menu = header.querySelector('[data-ml-mobile-menu]');
      if (!menu) return;
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        menu.hidden = expanded;
      });
    });
  }

  function setGalleryThumbState(gallery, selectedThumb) {
    gallery.querySelectorAll('[data-ml-thumb]').forEach(function (item) {
      var isSelected = item === selectedThumb;
      item.classList.toggle('is-active', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function swapGalleryImage(thumb) {
    var gallery = thumb.closest('[data-ml-gallery]');
    if (!gallery) return;

    var mainContainer = gallery.querySelector('.ml-product-gallery__main');
    if (!mainContainer) return;

    var full = thumb.getAttribute('data-full');
    if (!full) return;

    var alt = thumb.getAttribute('data-alt') || '';
    var currentImage = mainContainer.querySelector('[data-ml-main-image], img');
    var replacement = document.createElement('img');

    replacement.setAttribute('data-ml-main-image', '');
    replacement.src = full;
    replacement.alt = alt;
    replacement.loading = 'eager';
    replacement.decoding = 'async';
    replacement.style.display = 'block';
    replacement.style.width = '100%';
    replacement.style.height = 'auto';

    if (currentImage) {
      currentImage.replaceWith(replacement);
    } else {
      mainContainer.replaceChildren(replacement);
    }

    setGalleryThumbState(gallery, thumb);
  }

  function initProductGalleries() {
    document.querySelectorAll('[data-ml-gallery]').forEach(function (gallery) {
      var thumbs = gallery.querySelectorAll('[data-ml-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.setAttribute('aria-pressed', thumb.classList.contains('is-active') ? 'true' : 'false');
      });
    });
  }

  function initGalleryDelegation() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var thumb = target.closest('[data-ml-thumb]');
      if (!thumb) return;
      event.preventDefault();
      swapGalleryImage(thumb);
    }, true);
  }

  function initQuantityControls() {
    document.querySelectorAll('.ml-product-form').forEach(function (form) {
      var input = form.querySelector('input[name="quantity"]');
      var minus = form.querySelector('[data-ml-qty-minus]');
      var plus = form.querySelector('[data-ml-qty-plus]');
      if (!input || !minus || !plus) return;
      minus.addEventListener('click', function () {
        var current = parseInt(input.value || '1', 10);
        input.value = Math.max(1, current - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      plus.addEventListener('click', function () {
        var current = parseInt(input.value || '1', 10);
        var maximum = parseInt(input.max || '', 10);
        var next = Math.max(1, current + 1);
        input.value = Number.isFinite(maximum) ? Math.min(maximum, next) : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function initVariantSelectors() {
    document.querySelectorAll('[data-ml-variant-select]').forEach(function (select) {
      var productSection = select.closest('.ml-product-template');
      if (!productSection) return;
      var price = productSection.querySelector('[data-ml-product-price]');
      var addButton = productSection.querySelector('[data-ml-add-button]');

      function updateVariantState() {
        var selected = select.options[select.selectedIndex];
        if (!selected) return;
        var selectedPrice = selected.getAttribute('data-price');
        var available = selected.getAttribute('data-available') === 'true';
        if (price && selectedPrice) price.textContent = selectedPrice;
        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available ? 'Add to Cart' : 'Sold Out';
        }
      }

      select.addEventListener('change', updateVariantState);
      updateVariantState();
    });
  }

  function initCollectionFilters() {
    var toggle = document.querySelector('[data-ml-filter-toggle]');
    var sidebar = document.querySelector('[data-ml-filter-sidebar]');
    var close = document.querySelector('[data-ml-filter-close]');
    if (!toggle || !sidebar) return;
    toggle.addEventListener('click', function () {
      sidebar.classList.add('is-open');
    });
    if (close) {
      close.addEventListener('click', function () {
        sidebar.classList.remove('is-open');
      });
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') sidebar.classList.remove('is-open');
    });
  }

  function initProductRecommendations() {
    document.querySelectorAll('product-recommendations').forEach(function (element) {
      var url = element.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var newRecommendations = html.querySelector('product-recommendations');
          if (newRecommendations && newRecommendations.innerHTML.trim().length) {
            element.innerHTML = newRecommendations.innerHTML;
          }
        })
        .catch(function () { return null; });
    });
  }

  initGalleryDelegation();

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initProductGalleries();
    initQuantityControls();
    initVariantSelectors();
    initCollectionFilters();
    initProductRecommendations();
  });

  document.addEventListener('shopify:section:load', initProductGalleries);
})();
